import * as Yup from "yup";

const validationSchema = Yup.object({
  image: Yup.object().required("Image is required."),
  title: Yup.string(),
  buttonText: Yup.string(),
});

export { validationSchema };
